@if (loading) {
    <div style="position: relative;height: 400px;width:100%;">
        <spinner-overlay [overlay]="true"></spinner-overlay>
    </div>
}@else {
    <app-bar-chart [data]="data" [comparison]="comparisonName" [isStacked]="fieldType.isStacked()" [width]="width" [height]="height || chartHeight"
        [isCurrency]="fieldType.isCurrency()" [stacks]="getStacks()" [topNumber]="topNumber" [hideZeros]="hideZeros" (selectNodeEvent)="onSelect($event)" [xLabel]="xLabel">
    </app-bar-chart>
}